
import { mapState } from 'vuex'
import { bootstrap } from 'vue-gtag'
import analytics from '~/mixins.js/analytics'

export default {
  mixins: [analytics],
  data () {
    return {
      consents: {
        analytics: true
      }
    }
  },
  computed: mapState('cookie', ['visible']),
  methods: {
    loadAnalytics () {
      bootstrap().then(() => {
        setTimeout(() => {
          this.$matomo && this.$matomo.rememberConsentGiven()
          this.$gtag && this.$gtag.pageview(this.$route)
        }, 200)
      })
    },
    save () {
      this.$store.commit('cookie/setConsents', this.consents)
      if (this.consents.analytics && process.browser) {
        this.loadAnalytics()
      }
      this.$store.commit('cookie/setVisible', false)
      this.trackEvent('Cookies', 'Save')
    },
    acceptAll () {
      this.$store.commit('cookie/setConsents', {
        marketing: true,
        personalization: true,
        analytics: true
      })
      this.$store.commit('cookie/setVisible', false)
      this.loadAnalytics()
      this.trackEvent('Cookies', 'All')
    }
  }
}
